import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS6() {
    window.scrollTo(0,0);
    return (
        <div className="container">
             <img src="/images/clrhs6.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS6
